import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { finalize, map, share, tap } from 'rxjs/operators';

@Injectable()
export class ShIconService {
    private readonly ENDPOINT: string = 'assets/icons';
    private readonly ICON_NAMESPACE: string = 'sh-icon-';

    private loadedIcons: Map<string, SVGElement> = new Map<string, SVGElement>();
    private pendingIcons: Map<string, Observable<SVGElement>> = new Map<string, Observable<SVGElement>>();

    constructor(private readonly http: HttpClient) {}

    get$(iconName: string): Observable<SVGElement> {
        if (this.loadedIcons.has(iconName)) {
            return this.getIconFromLoadedMap$(iconName);
        } else if (this.pendingIcons.has(iconName)) {
            return this.getIconFromPendingMap$(iconName);
        } else {
            return this.getIconFromEndpoint$(iconName);
        }
    }

    private getIconFromLoadedMap$(iconName: string): Observable<SVGElement> {
        return of(this.loadedIcons.get(iconName)) as Observable<SVGElement>;
    }

    private getIconFromPendingMap$(iconName: string): Observable<SVGElement> {
        return this.pendingIcons.get(iconName) as Observable<SVGElement>;
    }

    private getIconFromEndpoint$(iconName: string): Observable<SVGElement> {
        const request$: Observable<SVGElement> = this.http
            .get(`${this.ENDPOINT}/${this.ICON_NAMESPACE}${iconName}.svg`, { responseType: 'text' })
            .pipe(
                map((svgString: string) => this.convertToSvgElement(svgString)),
                tap((svgElement: SVGElement) => this.loadedIcons.set(iconName, svgElement)),
                finalize(() => this.pendingIcons.delete(iconName)),
                share()
            );

        this.pendingIcons.set(iconName, request$);

        return request$;
    }

    private convertToSvgElement(svgString: string): SVGElement {
        const el: HTMLElement = document.createElement('DIV');
        el.innerHTML = svgString;

        return el.querySelector('svg') as SVGElement;
    }
}
